<script setup lang="ts">
/*
 * "Back to top" button: appears once the visitor has scrolled a full
 * viewport. Bottom-left so it never meets the toast stack (bottom-right).
 */
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { ArrowUp } from 'lucide-vue-next';

const { t } = useI18n();
const visible = ref(false);

function onScroll() {
  const past = window.scrollY > window.innerHeight;
  if (past !== visible.value) visible.value = past;
}

function toTop() {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
}

onMounted(() => {
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
});
onBeforeUnmount(() => window.removeEventListener('scroll', onScroll));
</script>

<template>
  <Transition
    enter-active-class="transition duration-200 motion-reduce:transition-none"
    leave-active-class="transition duration-150 motion-reduce:transition-none"
    enter-from-class="translate-y-2 opacity-0"
    leave-to-class="translate-y-2 opacity-0"
  >
    <button
      v-if="visible"
      type="button"
      class="btn-icon fixed bottom-[calc(var(--bottom-tabs-h)+1rem)] left-4 z-30 md:bottom-5 md:left-6"
      :aria-label="t('common.actions.backToTop')"
      @click="toTop"
    >
      <ArrowUp class="h-5 w-5" aria-hidden="true" />
    </button>
  </Transition>
</template>
